import { render, staticRenderFns } from "./work_statistics.vue?vue&type=template&id=ca0ba30e"
import script from "./work_statistics.vue?vue&type=script&lang=js"
export * from "./work_statistics.vue?vue&type=script&lang=js"
import style0 from "./work_statistics.vue?vue&type=style&index=0&id=ca0ba30e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports